import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { brand } from '../theme';
import { optimizedBackground } from '../utils/images';
import ContactInfo from '../components/ContactInfo';

const Home: React.FC = () => {
    return (
        <Box
            sx={{
                backgroundImage: `url(${optimizedBackground(brand.backgrounds.hero, 1920)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundColor: brand.overlay,
                backgroundBlendMode: 'overlay',
                width: '100%',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'center',
                color: 'common.white',
                px: 3,
                pt: { xs: 10, md: 12 },
                pb: 3,
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexGrow: 1,
                    maxWidth: 720,
                }}
            >
                <Typography variant="h3" gutterBottom>
                    Vom Baum bis zum Möbel, die Handwerkskunst mit Zukunft.
                </Typography>
                <Typography variant="body1" sx={{ mb: 3 }}>
                    Unsere Leidenschaft, vom Hobby zum Beruf. Mit Ihren Projekten und Aufträgen erfüllen wir unseren
                    Traum, eine eigene Firma zu gründen und betreiben.
                </Typography>
                <Button variant="contained" color="primary" component={RouterLink} to="/about">
                    MEHR
                </Button>
            </Box>

            <Typography variant="body1" sx={{ fontStyle: 'italic', textAlign: 'center', my: 2 }}>
                Coming Soon: Neuer Online-Shop für unsere Schneidbretter!
            </Typography>

            <ContactInfo direction="row" sx={{ justifyContent: 'center', textAlign: 'center' }} />
        </Box>
    );
};

export default Home;
